import { captureException } from '@sentry/browser';
import styled from '@emotion/styled';
import React, { useEffect } from 'react';

import { useGetRecommendedNextStepQuery } from 'src/modules/assessments/documents/getRecommendedNextStepQuery.generated';
import { WellbeingRenderScreenSectionNode } from 'src/modules/assessments/components/WellbeingRenderScreenSectionNode';
import { ScreenSectionFragment } from 'src/modules/dashboard/documents/getHomeScreen.generated';
import { SkeletonPlaceholder } from '@modernhealth/vital-components';

const Wrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: '0 auto',
    marginBottom: 40,
});

export enum YourNextStepTestID {
    Wrapper = 'YourNextStep.Wrapper',
}

export const YourNextStep: React.FC<{}> = () => {
    const { data, loading, error } = useGetRecommendedNextStepQuery({
        fetchPolicy: 'network-only',
    });

    const recNextStepBanner = data?.wellbeingReportScreen;

    useEffect(() => {
        if (error) {
            captureException(
                new Error('An unexpected getRecommendedNextStep query error was found'),
            );
        }
    }, [error]);

    if (loading) {
        return (
            <>
                <SkeletonPlaceholder marginTop={20} width="100%" height={40} />
                <SkeletonPlaceholder marginTop={10} width="100%" height={200} />
            </>
        );
    }

    if (error || !data) {
        return null;
    }

    return (
        <Wrapper data-testid={YourNextStepTestID.Wrapper}>
            {recNextStepBanner?.screenSections
                .filter((section): section is ScreenSectionFragment => section !== null)
                .map(section => (
                    <WellbeingRenderScreenSectionNode section={section} key={section.id} />
                ))}
        </Wrapper>
    );
};
